

class VariantRadiosFootwear extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions(disable = false, text, modifyClass = true) {
    const fieldsets = Array.from(this.querySelectorAll('fieldset.js.product-form__input'));
    // //console.log("fieldsets: ",fieldsets);
    var class_to_show = "";
     this.options = fieldsets.map((fieldset) => {
       try{

         //////////
          //document.getElementById("mySelect").firstElementChild.text;
          if(Array.from(fieldset.querySelectorAll('input'))){
            // console.log("gets: ",Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value);
            // //console.log(Array.from(fieldset.querySelectorAll('input')).firstElementChild.find((radio) => radio.checked).value)
          }
         //////////
         if(Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).name == 'Color'){
          // //console.log(Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value);
          if(Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value == 'Black Sole'){
            if(!class_to_show.includes("color_black")){
              class_to_show += ".color_black";
            }
            document.querySelectorAll('.color_white').forEach((element) => {
              element.style.display='none';
            });
            document.querySelectorAll('.color_black').forEach((element) => {
              element.style.display='inline-block';
            }); 
             if(document.querySelectorAll('.variant_blk').length > 0){
              document.querySelectorAll('.variant_wt').forEach((element) => {
                element.style.display='none';
              });
             }
            document.querySelectorAll('.variant_blk').forEach((element) => {
              element.style.display='inline-block';
            }); 
            
            //document.querySelector(".variant_blk").style.visibility = 'visible';
          } else if(Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value == 'White Sole'){
            if(!class_to_show.includes("color_white")){
              class_to_show += ".color_white";
            }
            document.querySelectorAll('.color_white').forEach((element) => {
              element.style.display='inline-block';
            });
            document.querySelectorAll('.color_black').forEach((element) => {
              element.style.display='none';
            });
            document.querySelectorAll('.variant_wt').forEach((element) => {
              element.style.display='inline-block';
            });
            document.querySelectorAll('.variant_blk').forEach((element) => {
              element.style.display='none';
            });
            
          }
         
  
        
        }
  
         
         if(Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).name == 'Style'){
          // //console.log(Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value);
          var get_style = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
          if(get_style.includes('Women') ){
            if(!class_to_show.includes("style_women")){
              class_to_show += ".style_women";
            }
            document.querySelectorAll('.style_women').forEach((element) => {
              element.style.display='inline-block';
            });
            document.querySelectorAll('.style_men').forEach((element) => {
              element.style.display='none';
            }); 
            if(document.querySelectorAll('.variant_blk').length > 0){
               document.querySelectorAll('.variant_wt').forEach((element) => {
                element.style.display='none';
              });
            }
            document.querySelectorAll('.variant_blk').forEach((element) => {
              element.style.display='inline-block';
            }); 
            
            //document.querySelector(".variant_blk").style.visibility = 'visible';
          } else if(get_style.includes('Men') ){
            if(!class_to_show.includes("style_men")){
              class_to_show += ".style_men";
            }
            document.querySelectorAll('.style_men').forEach((element) => {
              element.style.display='inline-block';
            });
            document.querySelectorAll('.style_women').forEach((element) => {
              element.style.display='none';
            });
            document.querySelectorAll('.variant_wt').forEach((element) => {
              element.style.display='inline-block';
            });
            document.querySelectorAll('.variant_blk').forEach((element) => {
              element.style.display='none';
            });
            
          }
         
  
        
        }


         if(Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).name == 'Size'){
          // //console.log(Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value);
          var get_style = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
          // //console.log(this.currentVariant)
           // console.log("getsssss: ",Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value);
        
        }

         
      
             return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
         
         

         
       }
       catch(e){
         // console.log("YO",e)
       }

    });

    var is_size_changed = false;
    var first_available_size = '';
    [...document.querySelectorAll('.style_women,.style_men')].map( element => element.style.display ="none" );
    [...document.querySelectorAll(class_to_show)].map( (element, index) => {

      // //console.log("class_to_show: ", class_to_show);
      if(index == 0){
        first_available_size = document.getElementById( element.getAttribute("for") );
      }

      // //console.log("first_available_size", first_available_size);

      if(document.getElementById( element.getAttribute("for") ).checked){
        is_size_changed = true;
      }
      
      element.style.display ="inline-block" 
    });
    
    if(!is_size_changed){
      first_available_size.checked = false;
      
      this.updateMasterId();
      this.updatePickupAvailability();
      this.removeErrorMessage();
  
      if (!this.currentVariant) {
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
      
    }
  }
}

customElements.define('variant-radios-footwear', VariantRadiosFootwear);





//On option change, preselect first size
let styleFieldset = document.querySelector('fieldset.Style');
if(styleFieldset){
  let allStyleLabels = styleFieldset.querySelectorAll('label');
  allStyleLabels.forEach(function(styleEle){
    styleEle.addEventListener('click', function(){
      
      let styleEleTxt = styleEle.textContent;
      styleEleTxt = styleEleTxt.trim();
      styleEleTxt = styleEleTxt.toLowerCase();
      // console.log('styleEleTxt', styleEleTxt);

      let styleText = '';
      if(styleEleTxt.includes('women')){
        styleText = 'style_women';
      }else{
        styleText = 'style_men';
      }
      // console.log('styleText', styleText);

      let checkedColor = document.querySelector('fieldset.Color input[type=radio]:checked+label').textContent; 
      checkedColor = checkedColor.trim();
      checkedColor = checkedColor.toLowerCase();
      // console.log('checkedColor', checkedColor);
      
      let colorText = '';
      if(checkedColor.includes('black')){
        colorText = 'color_black';
      }
      if(checkedColor.includes('white')){
        colorText = 'color_white';
      }
      // console.log('colorText', colorText);
      
      let sizeLabels = document.querySelectorAll('fieldset.Size label');
      for (let i = 0; i < sizeLabels.length; i++) {
        let sizeEleClassLists = sizeLabels[i].classList.value;
        if(sizeEleClassLists.includes(styleText) && sizeEleClassLists.includes(colorText)){
          // console.log('sizeEle::--> ', sizeLabels[i])
          sizeLabels[i].click();
          break;
        }
      }
           
    });
  })
}


let colorFieldset = document.querySelector('fieldset.Color');
if(colorFieldset){
  let allColorLabels = colorFieldset.querySelectorAll('label');
  allColorLabels.forEach(function(colorEle){
    colorEle.addEventListener('click', function(){
      
      let colorEleTxt = colorEle.textContent;
      colorEleTxt = colorEleTxt.trim();
      colorEleTxt = colorEleTxt.toLowerCase();
      // console.log('colorEleTxt', colorEleTxt);

      let colorText = '';
      if(colorEleTxt.includes('black')){
        colorText = 'color_black';
      }
      if(colorEleTxt.includes('white')){
        colorText = 'color_white';
      }
      // console.log('colorText', colorText);

      let checkedStyle = document.querySelector('fieldset.Style input[type=radio]:checked+label').textContent; 
      checkedStyle = checkedStyle.trim();
      checkedStyle = checkedStyle.toLowerCase();
      // console.log('checkedStyle', checkedStyle);
      
      let styleText = '';
      if(checkedStyle.includes('women')){
        styleText = 'style_women';
      }else{
        styleText = 'style_men';
      }
      // console.log('styleText', styleText);
      
      let sizeLabels = document.querySelectorAll('fieldset.Size label');
      for (let i = 0; i < sizeLabels.length; i++) {
        let sizeEleClassLists = sizeLabels[i].classList.value;
        if(sizeEleClassLists.includes(styleText) && sizeEleClassLists.includes(colorText)){
          // console.log('sizeEle::--> ', sizeLabels[i])
          sizeLabels[i].click();
          break;
        }
      }
           
    });
  })
}

//click first option
// setTimeout(function(){
  // document.querySelector('fieldset.Style label').click();
// }, 700);

document.addEventListener('DOMContentLoaded', function(){  
  console.log('Footwear template');
  
  let prod_images = document.querySelectorAll('.product__media-list .product__media-item');
  // console.log('prod_images2', prod_images);
  
  let checkedStyle = document.querySelector('fieldset.Style input:checked')?.value;
  // console.log('checkedStyle1', checkedStyle);
  let checkedColor = document.querySelector('fieldset.Color input:checked')?.value;
  // console.log('checkedColor1', checkedColor);

  let styleText = '';
  if(checkedStyle.includes('Women')){
    styleText = 'style_women';
  }else{
    styleText = 'style_men';
  }
  // console.log('styleText1', styleText);

  let colorText = '';
  if(checkedColor.includes('Black')){
    colorText = 'color_black';

    //update media
    if(prod_images){
      prod_images.forEach(function(prdEle){      
        let prdEleClasslist = prdEle.classList;
        if(prdEleClasslist.contains('variant_blk')){
            prdEle.style.display = 'inline-block';
        }
        if(prdEleClasslist.contains('variant_wt')){
            prdEle.style.display = 'none';
        }
      });
    }
  }
  if(checkedColor.includes('White')){
    colorText = 'color_white';

    //update media
    if(prod_images){      
      prod_images.forEach(function(prdEle){      
        let prdEleClasslist = prdEle.classList;
        if(prdEleClasslist.contains('variant_blk')){
            prdEle.style.display = 'none';
            // console.log('in blk', prdEle)
        }
        if(prdEleClasslist.contains('variant_wt')){
            prdEle.style.display = 'inline-block';
            // console.log('in wt', prdEle)
        }
      });
    }    
  }
  // console.log('colorText1', colorText);

  let sizeLabels = document.querySelectorAll('fieldset.Size label');
  for (let i = 0; i < sizeLabels.length; i++) {
    let sizeEleClassLists = sizeLabels[i].classList.value;
    if(sizeEleClassLists.includes(styleText) && sizeEleClassLists.includes(colorText)){
      // // console.log('sizeEle::--> ', sizeLabels[i]);
      sizeLabels[i].style.display = 'inline-block';
      // sizeLabels[i].click();
      // break;
    }else{
      sizeLabels[i].style.display = 'none';
    }
  }
  
});
